import WebApp from '@twa-dev/sdk';
import type { DesignId } from './design';

// [шапка, фон] вебвью Telegram под каждый дизайн × тему
const DESIGN_TG_COLORS: Record<DesignId, { light: [`#${string}`, `#${string}`]; dark: [`#${string}`, `#${string}`] }> = {
  neo: { light: ['#ffffff', '#f4f5f8'], dark: ['#0b0d12', '#0b0d12'] },
  classic: { light: ['#ffffff', '#f5f5f5'], dark: ['#1a1a2e', '#16213e'] },
  air: { light: ['#ffffff', '#f7f8fb'], dark: ['#1c1d24', '#131419'] },
  glass: { light: ['#6366f1', '#8b5cf6'], dark: ['#1e1b4b', '#312e81'] },
  aurora: { light: ['#0b0f1a', '#0b0f1a'], dark: ['#0b0f1a', '#0b0f1a'] },
  ukraine: { light: ['#0057B7', '#F7FAFF'], dark: ['#0A1A2F', '#0A1A2F'] },
  leaf: { light: ['#ffffff', '#F6FAF6'], dark: ['#0D1712', '#0D1712'] },
  vyshyvanka: { light: ['#FAF3E7', '#FAF3E7'], dark: ['#241C16', '#241C16'] },
};

export function applyTelegramColors(design: DesignId, theme: 'light' | 'dark') {
  try {
    const [header, bg] = DESIGN_TG_COLORS[design][theme];
    WebApp.setHeaderColor(header);
    WebApp.setBackgroundColor(bg);
  } catch {}
}

// ---------------------------------------------------------------------------
// Тема: ручной выбор пользователя («Темна» по умолчанию, есть «Світла» и
// «Системна» — следовать за Telegram/ОС). Живёт в localStorage, пре-пейнт
// скрипт в index.html применяет её до загрузки бандла, чтобы не было вспышки.
// ---------------------------------------------------------------------------

export type ThemePreference = 'dark' | 'light' | 'system';

const THEME_KEY = 'barter-theme';

export function getThemePreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light' || stored === 'system') return stored;
  } catch {}
  return 'dark';
}

export function saveThemePreference(pref: ThemePreference) {
  try {
    localStorage.setItem(THEME_KEY, pref);
  } catch {}
}

/** Финальная тема с учётом выбора: системная → тема Telegram/ОС, иначе выбор. */
export function getTheme(pref: ThemePreference = getThemePreference()): 'light' | 'dark' {
  if (pref !== 'system') return pref;
  try {
    return WebApp.colorScheme === 'light' ? 'light' : 'dark';
  } catch {
    return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  }
}

export function initTelegram() {
  try {
    WebApp.ready();
    WebApp.expand();
    let design: DesignId = 'ukraine';
    try {
      const stored = localStorage.getItem('barter-design') as DesignId | null;
      if (
        stored === 'air' ||
        stored === 'glass' ||
        stored === 'aurora' ||
        stored === 'classic' ||
        stored === 'neo' ||
        stored === 'ukraine' ||
        stored === 'leaf' ||
        stored === 'vyshyvanka'
      ) {
        design = stored;
      }
    } catch {}
    applyTelegramColors(design, getTheme());
  } catch {
    console.log('[Barter] Running outside Telegram');
  }
}

export function getTelegramUser() {
  try {
    const user = WebApp.initDataUnsafe?.user;
    return user
      ? {
          id: user.id,
          firstName: user.first_name,
          lastName: user.last_name || '',
          username: user.username || '',
        }
      : null;
  } catch {
    return null;
  }
}

export function isTelegram() {
  try {
    return WebApp.platform !== 'unknown';
  } catch {
    return false;
  }
}
